export const translatesSendEmailCodeError = (errorCode: string | undefined): string => {
  switch (errorCode) {
    case "employee_does_not_exist":
      return "Diese E-Mail-Adresse wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe.";
    case "sent_link":
      return "Der Link wurde erfolgreich versendet.";
    case "missing_email":
      return "Bitte geben Sie eine E-Mail-Adresse ein.";
    case "already_logged_in":
      return "Sie sind bereits angemeldet.";
    case "ok":
      return "Die Aktion war erfolgreich.";
    case "not_allowed_to_access_portal":
      return "Sie haben keine Berechtigung, auf dieses Portal zuzugreifen. Bitte kontaktieren Sie Ihren Administrator.";
    case "failed_to_send_code":
      return "Der Code konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.";
    default:
      return "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
  }
}

export const translatesVerifyCodeError = (errorCode: string | undefined) : string => {
  switch (errorCode) {
    case "missing_email":
      return "Bitte geben Sie eine E-Mail-Adresse ein.";
    case "missing_login_code":
      return "Bitte geben Sie den Anmeldecode ein.";
    case "employee_does_not_exist":
      return "Dieser Mitarbeiter existiert nicht im System.";
    case "not_allowed_to_use_portal":
      return "Sie haben keine Berechtigung, dieses Portal zu nutzen.";
    case "login_code_incorrect":
      return "Der eingegebene Anmeldecode ist nicht korrekt.";
    case "logged_in":
      return "Sie wurden erfolgreich angemeldet.";
    case "too_many_attempts_please_resent_code":
      return "Zu viele Versuche. Bitte fordern Sie einen neuen Code an.";
    case "no_login_code_for_employee":
      return "Es ist kein Anmeldecode für diesen Mitarbeiter vorhanden.";
    default:
      return "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
  }
}